"use strict";

exports.__esModule = true;
exports.ReportListAccordianView = ReportListAccordianView;
var _react = _interopRequireWildcard(require("react"));
var _ReportListAccordianWrapper = require("./ReportListAccordianWrapper");
var _ReportListAccordianGridView = require("./ReportListAccordianGridView");
var _utils = require("./utils");
var _SortButton = require("../../Core/SortButton");
var _Profile = require("../../Profile");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _useAdministrativeTenant = _interopRequireDefault(require("../../AdministrativeTenant/Hooks/useAdministrativeTenant"));
var _constants = require("../../constants");
var _excluded = ["onItemClick", "items", "selectedIds", "compact", "tags"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Shows a list of reports.
 */
function ReportListAccordianView(props) {
  var _useContext = (0, _react.useContext)(_Profile.ProfileContext),
    userRolesDetails = _useContext.userRolesDetails,
    user = _useContext.user;
  var isAdministrativeTenant = (0, _useAdministrativeTenant["default"])();
  var onItemClick = props.onItemClick,
    items = props.items,
    _props$selectedIds = props.selectedIds,
    selectedIds = _props$selectedIds === void 0 ? [] : _props$selectedIds,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? false : _props$compact,
    tags = props.tags,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var thumbnailSize = compact ? 140 : 64;
  function renderReportsForTag(tag) {
    if (reportsKeyedByTags[tag]) {
      return /*#__PURE__*/_react["default"].createElement(_ReportListAccordianGridView.ReportListAccordianGridView, {
        items: reportsKeyedByTags[tag],
        onItemClick: onItemClick,
        selectedIds: selectedIds,
        thumbnailSize: thumbnailSize
      });
    }
    return null;
  }
  function renderTag(tag) {
    return /*#__PURE__*/_react["default"].createElement(_utils.ReportListItemHeading, {
      "data-testid": "ReportAccordianItem.Heading"
    }, tag);
  }
  var reportsKeyedByTags;
  var tagList;
  var filteredItems = items;
  if (!isAdministrativeTenant) {
    filteredItems = (0, _ConfigurableLayout.filterLayoutElementsByUserRoles)(userRolesDetails, filteredItems);
    filteredItems = (0, _ConfigurableLayout.filterLayoutElementsByUser)(user, filteredItems);
  }
  if (tags) {
    reportsKeyedByTags = filteredItems.reduce(function (acc, item) {
      var doesItemHaveTag = false;
      tags.forEach(function (tag) {
        // $FlowFixMe
        if (item.tags && item.tags.includes(tag)) {
          // flow can't handle multiple ORs
          doesItemHaveTag = true;
          acc[tag] = acc[tag] ? [].concat(acc[tag], [item]) : [item];
        }
      });
      if (!doesItemHaveTag) {
        // $FlowFixMe
        if (item.path) {
          // flow can't handle multiple ORs
          acc.Legacy = acc.Legacy ? [].concat(acc.Legacy, [item]) : [item];
        } else {
          acc[_constants.TAG_UNTAGGED] = acc[_constants.TAG_UNTAGGED] ? [].concat(acc[_constants.TAG_UNTAGGED], [item]) : [item];
        }
      }
      return acc;
    }, {});

    // Get Legacy Reports
    tagList = Object.keys(reportsKeyedByTags).filter(function (tag) {
      return tag !== _constants.TAG_UNTAGGED;
    });
    tagList = (0, _SortButton.applySortToValues)(tagList, "asc");
    tagList.push(_constants.TAG_UNTAGGED);
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      style: {
        width: "100%",
        height: "100%"
      },
      "data-testid": "ReportListAccordianView"
    }, extra), /*#__PURE__*/_react["default"].createElement(_ReportListAccordianWrapper.ReportListAccordianWrapper, {
      items: tagList,
      renderItem: renderTag,
      renderItemContent: renderReportsForTag,
      getKey: function getKey(tag) {
        return tag;
      },
      itemWidth: "100%",
      expandedViewHeight: "fit-content",
      expandedViewMaxHeight: "430px"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_utils.ReportListContainer, _extends({
    "data-testid": "ReportList"
  }, extra), filteredItems.map(function (item) {
    // $FlowFixMe
    if (item.path) {
      // flow can't handle multiple ORs
      return (0, _utils.renderExternalRow)({
        item: item,
        thumbnailSize: thumbnailSize
      });
    }
    // $FlowFixMe
    return (0, _utils.renderReportListRow)({
      item: item,
      selectedIds: selectedIds,
      onItemClick: onItemClick,
      thumbnailSize: thumbnailSize
    });
  }));
}